export default {"src":"https://fishbrain.com/_next/static/media/White_Mono_Panorama.c3e0fe5d.svg","height":241,"width":1000,"blurWidth":0,"blurHeight":0};